import { render, staticRenderFns } from "./ExFoldForm.vue?vue&type=template&id=8e1b5f42&scoped=true"
import script from "./ExFoldForm.vue?vue&type=script&lang=js"
export * from "./ExFoldForm.vue?vue&type=script&lang=js"
import style0 from "./ExFoldForm.vue?vue&type=style&index=0&id=8e1b5f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1b5f42",
  null
  
)

export default component.exports